// extracted by mini-css-extract-plugin
export var darkMode = "persons-module--darkMode--e0325";
export var griditems = "persons-module--griditems--e0736";
export var items = "persons-module--items--a412a";
export var linklinkedin = "persons-module--linklinkedin--f10e2";
export var name = "persons-module--name--459a0";
export var oneitem = "persons-module--oneitem--ee6be";
export var photo = "persons-module--photo--e34ee";